<template>
    <div>
        <PageTitle v-if="error" :title="$t('gracias.error_title')"/>
        <PageTitle v-else :title="$t('gracias.title')" sectionClass="buy_success"/>

        <FirstBanner/>

        <section class="padding-vertical-content pt-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-10" v-if="error">
                        <div class="text-center">
                            <div class="h5">
                                {{ $t("gracias.error") }}
                            </div>
                            <div>
                                <p>{{ $t("gracias.mas_tarde") }}</p>
                            </div>
                            <router-link :to="{ name: 'front.home' }" class="button button effect-button mb-0 mt-3">
                                {{ $t("gracias.volver") }}
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 col-lg-10" v-else>
                        <template v-if="loading">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <div class="text-center my-5 h4">
                                        {{ $t("gracias.procesando", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}
                                    </div>
                                </div>
                                <div class="col-12" style="margin-bottom: 60px; margin-top: 20px">
                                    <LoaderComponent />
                                </div>
                            </div>
                        </template>
                        <div v-else>
                            <BasesComponent
                                :base="datos_comprador"
                                :tpv_order="tpv_order"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import BasesComponent from '@/components/frontend/compra/bases/BasesComponent';

    export default {
        props: ['session_id', 'tpv_order'],
        data() {
            return {
                datos_comprador: null,
                error: false,
                loading: false
            }
        },
        created() {
            if (this.session_id == 0 && this.tpv_order == 0) {
                this.error = true;
            } else {
                if (this.$route.query.error == "true") {
                    this.error = true;
                } else {
                    this.getDatosComprador();
                }
            }
        },
        methods: {
            getDatosComprador() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    sesion_id: this.session_id,
                    tpv_order: this.tpv_order,
                };

                this.$store.dispatch(this.config.getVuexAlias('front.bases.sesion.get'), params).then(res => {
                    this.datos_comprador = res.data.datos_comprador;
                }).catch(error => {
                    this.error = true;
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            PageTitle, FirstBanner, BasesComponent
        }
    }
</script>